import { type ReactNode, useState } from 'react'

import { ChevronFlip } from '@subaio/components'

import { Button } from './Button'
import { Container } from './Container'
import { Content } from './Content'

type Props = {
	children: ReactNode
	isExpandedInitially?: boolean

	renderTitle?: (isExpanded: boolean) => ReactNode
}

export const ExpandButton = ({
	children,
	isExpandedInitially = false,
	renderTitle = (isExpanded) => (isExpanded ? 'Hide child attributes' : 'Show child attributes'),
}: Props) => {
	const [isExpanded, setIsExpanded] = useState(isExpandedInitially)

	return (
		<Container>
			<Button isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
				<ChevronFlip isActive={isExpanded} style={{ marginBottom: '5px' }} />
				<span>{renderTitle(isExpanded)}</span>
			</Button>
			<Content>{isExpanded ? children : null}</Content>
		</Container>
	)
}
